import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

import { useTranslate } from "@/composables";
import { EXPERIMENTS_CREATOR_GIFT_GUIDES } from "@/utils/experiments/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'CreatorShopProductsTab',
  props: {
  productIds: { type: Array as () => string[], required: true },
  profileId: { type: String, required: true },
  displayName: { type: String, required: true },
  isSearch: { type: Boolean, required: true },
  isVisible: { type: Boolean, required: true, default: false },
  hasProductsSets: { type: Boolean, default: false },
  showLoading: { type: Boolean, required: true },
  showError: { type: Boolean, required: true },
},
  emits: ["page"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "page"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const { t } = useTranslate();

const productsFeedTitle = computed(() => {
  if (props.isSearch) {
    return t("Matching products").value;
  }
  return t("Recent products").value;
});

const onPage = () => {
  emits("page");
};

return { __sfc: true,props, emits, t, productsFeedTitle, onPage, EXPERIMENTS_CREATOR_GIFT_GUIDES }
}

})